export default "__VITE_ASSET__ByW_P1rV__"